import { Select, MenuItem } from "@mui/material";
import { useLanguages } from "../../../context/LanguagesContext";

export const LanguageSelector = () => {
  const { languages, handleChange, selectedLanguage } = useLanguages();

  return (
    <Select
      value={selectedLanguage}
      onChange={handleChange}
      size="small"
      sx={{ backgroundColor: "white" }}
    >
      {languages?.map((l, index) => (
        <MenuItem key={l.value || index} value={l.value}>
          {l.label}
        </MenuItem>
      ))}
    </Select>
  );
};